import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLicense } from '@syncfusion/ej2-base';

registerLicense(
  'Ngo9BigBOggjGyl/VkV+XU9AclREQmFWfFN0Q3NQdVtyflVAcDwsT3RfQFtjTH5QdERmWn9ecnRTRWtfUg==',
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(() => {
    setTimeout(function () {
      navigator.serviceWorker.register('ngsw-worker.js');
    }, 1000);
  })
  .catch((err) => {});
